module.exports = __webpack_public_path__ + "static/media/stream_teams.e9dc0877.svg";